import { render, staticRenderFns } from "./OrdersSearchResults.vue?vue&type=template&id=90ba2650"
import script from "./OrdersSearchResults.vue?vue&type=script&lang=js"
export * from "./OrdersSearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports